import { createValidIcon } from '@ui/icons/utils/type-helper'

export const UnfoldMoreIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      id='unfoldmore-icon'
      data-testid='unfoldmore-icon'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='icon-unfold-more'>
        <path
          id='Union'
          d='M15.2931 14.293C15.6836 13.9025 16.3166 13.9025 16.7072 14.293C17.0974 14.6835 17.0976 15.3166 16.7072 15.707L12.7072 19.707C12.3167 20.0974 11.6836 20.0973 11.2931 19.707L7.2931 15.707C6.9026 15.3165 6.90265 14.6835 7.2931 14.293C7.65921 13.9269 8.23821 13.9043 8.63099 14.2246L8.70716 14.293L12.0001 17.5859L15.2931 14.293ZM11.3693 4.22462C11.762 3.90427 12.341 3.92686 12.7072 4.29298L16.7072 8.29298L16.7755 8.36915C17.0956 8.76192 17.0732 9.34101 16.7072 9.70704C16.3411 10.073 15.762 10.0955 15.3693 9.7754L15.2931 9.70704L12.0001 6.41407L8.70716 9.70704C8.31671 10.0974 7.68361 10.0973 7.2931 9.70704C6.9026 9.31654 6.90265 8.68351 7.2931 8.29298L11.2931 4.29298L11.3693 4.22462Z'
          fill={color}
        />
      </g>
    </svg>
  )
})
